import { errorMessage, isApiError, problemKey } from '@/shared/api';

import { billingCopy } from './copy';

/** De 5xx van de betaalstroom die de API zelf in gewone taal uitlegt. */
const PAYMENT_PROBLEMS = ['payment-provider-unavailable', 'payment-provider-failed'];

/**
 * De zin onder een mislukte actie of een kaart die niet laadde.
 *
 * De meldingen uit het facturatiedomein zijn Nederlands en precies ("Een factuur
 * met status "Betaald" kan niet naar "Verstuurd"."), net als de veldmeldingen bij
 * een 422: die komen ongewijzigd door. Een algemene 403, 404 of 500 draagt de
 * Engelse tekst van het framework; daarvoor staat hier een eigen zin.
 */
export function describeBillingError(error: unknown): string {
    if (!isApiError(error)) {
        return errorMessage(error);
    }

    switch (error.kind) {
        case 'offline':
            return billingCopy.errorOffline;
        case 'unauthorized':
            return billingCopy.errorSession;
        case 'forbidden':
            return billingCopy.errorForbidden;
        case 'notFound':
            return problemKey(error) === 'not-found'
                ? billingCopy.errorNotFound
                : errorMessage(error);
        case 'validation':
        case 'conflict':
        case 'network':
        case 'timeout':
            return errorMessage(error);
        case 'rateLimited':
            return billingCopy.errorRateLimited;
        default:
            /*
             * Online betalen dat niet is ingesteld of een betaalprovider die niet
             * antwoordt: de API zegt het in een rustige zin ("er is niets betaald"),
             * en die is beter dan "er ging iets mis".
             */
            return PAYMENT_PROBLEMS.includes(problemKey(error) ?? '')
                ? errorMessage(error)
                : billingCopy.errorServer;
    }
}
